import Raven from 'raven-js'
import { NODE_ENV, APP_ENV, APP_VERSION, SENTRY_PUBLIC_KEY } from '../config'

export default boot

function boot() {
  /**
   * Initialize and configure Raven
   */

  // wrap in try to prevent raven from causing add'l exceptions...
  try {
    if (NODE_ENV === 'production') {
      Raven.config(SENTRY_PUBLIC_KEY).install()
      Raven.setEnvironment(APP_ENV)
      Raven.setRelease(APP_VERSION)
    }
  } catch (e) {
    console.error(e)
  }

  // Pass release and environment info to Sentry after it is loaded
  window.analytics.ready(() => {
    const { FS } = window

    // Include fullstory link in Sentry extras.
    // FullStory does not include `getCurrentSessionURL` in it's initialize snippet
    // so we need to use their global `window._fs_ready` if the library has yet to load.
    if (FS && FS.getCurrentSessionURL) {
      const { FS } = window
      if (FS && FS.getCurrentSessionURL) {
        const linkToNow = true
        Raven.setExtraContext({ fullstory: FS.getCurrentSessionURL(linkToNow) })
      }
    } else {
      window._fs_ready = addFullStoryUrl
    }
  })
}

function addFullStoryUrl() {
  const { FS } = window
  if (FS && FS.getCurrentSessionURL) {
    const linkToNow = true
    Raven.setExtraContext({ fullstory: FS.getCurrentSessionURL(linkToNow) })
  }
}



// WEBPACK FOOTER //
// ./lib/boot.js